import { render, staticRenderFns } from "./CourseVideoPlayerPreviousNext.vue?vue&type=template&id=5d1bd37d&scoped=true"
import script from "./CourseVideoPlayerPreviousNext.vue?vue&type=script&lang=js"
export * from "./CourseVideoPlayerPreviousNext.vue?vue&type=script&lang=js"
import style0 from "./CourseVideoPlayerPreviousNext.vue?vue&type=style&index=0&id=5d1bd37d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1bd37d",
  null
  
)

export default component.exports